import { useMutation } from "@tanstack/react-query";
import { customAxios } from "lib/axios";
import { showNotification } from "@mantine/notifications";
import { AxiosError } from "axios";

interface DeleteOrgResponse {
  success: boolean;
  message: string;
}

export const useDeleteOrganization = () =>
  useMutation<DeleteOrgResponse, AxiosError<{ message?: string }>, string>({
    mutationFn: async (orgId: string) => {
      const response = await customAxios.delete<DeleteOrgResponse>(
        `/organizations/${orgId}/delete`
      );
      return response.data;
    },
    onSuccess: () => {
      showNotification({
        title: "Success",
        message: "Organization has been deleted successfully",
        color: "green",
      });
    },
    onError: (error: AxiosError<{ message?: string }>) => {
      const errorMsg = error?.response?.data?.message || "Failed to delete organization";
      showNotification({
        title: "Error",
        message: errorMsg,
        color: "red",
      });
    },
  });
